export const FARMDOK_AUTH_CHECK_EMAIL_VISITED = 'FARMDOK_AUTH_CHECK_EMAIL_VISITED';
export const FARMDOK_AUTH_REGISTRATION_PROCESS_ACTIVE = 'FARMDOK_AUTH_REGISTRATION_PROCESS_ACTIVE';
export const FARMDOK_AUTH_CURRENT_COMPANIES_AND_PROCESS_ORDER_NAME =
  'FARMDOK_AUTH_CURRENT_COMPANIES_AND_PROCESS_ORDER_NAME';
